import { marked, Renderer } from "marked";

function inlineMarked(options: marked.MarkedOptions): marked.MarkedOptions {
  const space = " ";
  const emptyText = (): string => "";
  const plainText = (text: string): string => text + space;

  const renderer: Renderer = {
    options: options.renderer.options,

    blockquote: (quote: string): string => quote,
    br: emptyText,
    checkbox: (checked: boolean) => (checked ? "[x]" : "[ ]") + space,
    code: (code: string): string => code,
    codespan: plainText,
    del: plainText,
    em: plainText,
    html: (html: string): string => html,
    heading: plainText,
    hr: emptyText,
    image: (href: string, title: string, text: string): string => text,
    link: (href: string, title: string, text: string): string => text,
    list: (body: string): string => body,
    listitem: plainText,
    paragraph: plainText,
    table: (header: string, body: string) => header + space + body,
    tablerow: (content: string) => content,
    tablecell: (content: string) => content,
    text: plainText,
    strong: plainText,
  };

  return {
    ...options,
    renderer,
  };
}

const renderer = new Renderer();
renderer.link = (href: string, title: string, text: string): string => `<a href='${href}' target='_blank' title='${title ? title : ""}'>${text}</a>`;

export const markedOptions: marked.MarkedOptions = {
  sanitize: true,
  renderer,
};

export const inlineMarkedOptions = inlineMarked(markedOptions);
